import { render, staticRenderFns } from "./ProductsField.vue?vue&type=template&id=3bea56d9"
import script from "./ProductsField.vue?vue&type=script&lang=js"
export * from "./ProductsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports